import { CameraView } from "@/utils/cam-view";
import { GUID } from "@faro-lotv/foundation";
import { Vector3 } from "three";

export type WalkSceneEvent = {
  targetElementId: GUID;
  lookAt?: Vector3;
  cameraView?: CameraView;
};

/**
 * A class to facilitate dispatching of scene events (such as lookAt and setCameraView) to the
 * correct sub-component of walk mode.
 */
export class WalkSceneEventsPostman {
  #events = new Map<GUID, WalkSceneEvent>();

  /**
   * Stores a new event in the postman's bag.
   *
   * @param event The new event to register in the postman's bag
   */
  push(event: WalkSceneEvent): void {
    if (this.#events.has(event.targetElementId)) {
      return;
    }
    this.#events.set(event.targetElementId, event);
  }

  /**
   * Asks the postman whether there is new mail for the given element.
   *
   * @param targetElementId guid of the destination element
   * @returns Any event the postman has for the mentioned guid
   */
  pop(targetElementId: GUID): WalkSceneEvent | undefined {
    if (this.#events.has(targetElementId)) {
      const result = this.#events.get(targetElementId);
      this.#events.delete(targetElementId);
      return result;
    }
  }
}
